import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { ProfileOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.sort 排序越小越排前
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/question',
    name: 'question',
    redirect: '/question/index',
    component: Layout,
    meta: {
      title: '题库管理',
      icon: renderIcon(ProfileOutlined),
      sort: 1,
    },
    children: [
      {
        path: 'index',
        name: 'question-index',
        meta: {
          title: '题目列表',
        },
        component: () => import('@/views/question/index/index.vue'),
      },
      {
        path: 'create',
        name: 'question-create',
        meta: {
          title: '新增题目',
          hidden: true,
        },
        component: () => import('@/views/question/createOrEdit/index.vue'),
      },
      {
        path: 'edit/:id',
        name: 'question-edit',
        meta: {
          title: '修改题目',
          hidden: true,
        },
        component: () => import('@/views/question/createOrEdit/index.vue'),
      },
      {
        path: 'question-suite-category',
        name: 'question-suite-category',
        meta: {
          title: '套题分类',
        },
        component: () => import('@/views/questionSuiteCategory/index/index.vue'),
      },
      {
        path: 'question-suite',
        name: 'question-suite',
        meta: {
          title: '套题列表',
        },
        component: () => import('@/views/questionSuite/index/index.vue'),
      },
      {
        path: 'question-suite/create',
        name: 'question-suite-create',
        meta: {
          title: '新增套题',
          hidden: true,
        },
        component: () => import('@/views/questionSuite/createOrEdit/index.vue'),
      },
      {
        path: 'question-suite/edit/:id',
        name: 'question-suite-edit',
        meta: {
          title: '修改套题',
          hidden: true,
        },
        component: () => import('@/views/questionSuite/createOrEdit/index.vue'),
      },
      {
        path: 'question-suite-module-question/:id',
        name: 'question-suite-module-question',
        meta: {
          title: '模块下的题目',
          hidden: true,
        },
        component: () => import('@/views/questionSuite/questionList/index.vue'),
      },
      {
        path: 'question-custom-suite',
        name: 'question-custom-suite',
        meta: {
          title: '组题列表',
        },
        component: () => import('@/views/questionCustomSuite/index/index.vue'),
      },
      {
        path: 'question-custom-suite/create',
        name: 'question-custom-suite-create',
        meta: {
          title: '新增组题',
          hidden: true,
        },
        component: () => import('@/views/questionCustomSuite/createOrEdit/index.vue'),
      },
      {
        path: 'question-custom-suite/edit/:id',
        name: 'question-custom-suite-edit',
        meta: {
          title: '修改组题',
          hidden: true,
        },
        component: () => import('@/views/questionCustomSuite/createOrEdit/index.vue'),
      },
      {
        path: 'question-choose-suite',
        name: 'question-choose-suite',
        meta: {
          title: '选题列表',
        },
        component: () => import('@/views/questionChooseSuite/index/index.vue'),
      },
      {
        path: 'question-choose-suite/create',
        name: 'question-choose-suite-create',
        meta: {
          title: '新增选题',
          hidden: true,
        },
        component: () => import('@/views/questionChooseSuite/createOrEdit/index.vue'),
      },
      {
        path: 'question-choose-suite/edit/:id',
        name: 'question-choose-suite-edit',
        meta: {
          title: '修改选题',
          hidden: true,
        },
        component: () => import('@/views/questionChooseSuite/createOrEdit/index.vue'),
      },
    ],
  },
];

export default routes;
